var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114439_38297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.78727 9.66941L3.23033 11.7485L1.19474 11.7916C0.586396 10.6633 0.241333 9.37229 0.241333 8.00041C0.241333 6.67382 0.563958 5.42282 1.13583 4.32129H1.13627L2.94852 4.65354L3.7424 6.45491C3.57624 6.93932 3.48568 7.45932 3.48568 8.00041C3.48574 8.58766 3.59211 9.15032 3.78727 9.66941Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1016 6.50586C16.1935 6.9898 16.2414 7.48958 16.2414 8.00036C16.2414 8.57311 16.1811 9.1318 16.0664 9.6707C15.677 11.5045 14.6594 13.1059 13.2497 14.239L13.2493 14.2386L10.9667 14.1221L10.6436 12.1054C11.579 11.5569 12.31 10.6984 12.695 9.6707H8.41724V6.50586H12.7575H16.1016Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 14.2382L13.2498 14.2386C11.8788 15.3406 10.1372 15.9999 8.24142 15.9999C5.19482 15.9999 2.54604 14.2971 1.19482 11.7911L3.78736 9.66895C4.46295 11.472 6.20229 12.7555 8.24142 12.7555C9.11789 12.7555 9.93901 12.5186 10.6436 12.105L13.2493 14.2382Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3477 1.84175L10.7561 3.9635C10.0269 3.50769 9.16486 3.24437 8.24136 3.24437C6.15608 3.24437 4.38421 4.58678 3.74246 6.4545L1.1363 4.32088H1.13586C2.4673 1.75384 5.14949 0 8.24136 0C10.1825 0 11.9622 0.691437 13.3477 1.84175Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114439_38297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.241333)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.5d130e69b85cf7d96972f52d47a809f1.svg";
export { ForwardRef as ReactComponent };